/**
 * Shared toast notification utility.
 * Creates a #ds-toast-container on first use and appends toast messages to it.
 *
 * @param {string} message
 * @param {'success'|'error'|'info'} type
 * @param {number} duration  ms before the toast disappears
 */
export function showToast(message, type = 'success', duration = 3500) {
    let container = document.getElementById('ds-toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'ds-toast-container';
        document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.className = `ds-toast ds-toast--${type}`;
    toast.textContent = message;
    container.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add('ds-toast--visible'));

    setTimeout(() => {
        toast.classList.remove('ds-toast--visible');
        toast.addEventListener('transitionend', () => toast.remove(), { once: true });
    }, duration);
}
